// /**
//  * This file is used to aggregate all the css files that are used by our views.  This is necessary because with webpack chunks,
//  * extract text is unable to create a style sheet for individual chunks.  To get around this, we load all the chunked styles
//  * here.
//  */
//

//Global Nav
import 'epic-games-nav/lib/epicGamesNav.epic-games-nav.css';
import 'epic-games-nav/lib/theme.unreal_engine.epic-games-nav.css';

//Footer
import 'epic-games-footer/lib/epicGamesFooter.epic-games-footer.css';

//common widget style
import './common/modal/Modal.sass';
import './common/modal/ErrorModal.sass';
import './common/alert/AlertStyle.sass';
import './common/select/Select.sass';
import './common/tab/Tabs.sass';
import './common/icon/Icon.sass';
import './common/button/Button.sass';
import './common/button/IconButton.sass';
import './common/spacer/Spacer.sass';
import './common/text/Text.sass';
import './comment/Comment.sass';
import './common/select/SortSelect.sass';
import './common/pagination/Pagination.sass';
import './common/summaryInput/SummaryInput.sass';
import './common/richTextEditor/RichTextEditor.sass';
import './common/richTextEditor/RichTextContent.sass';
import './common/fileUpload/FileUpload.sass';
import './common/readMoreText/ReadMoreText.sass';
import './common/validateSelect/ValidateSelect.sass';
import './common/validateTextArea/ValidateTextArea.sass';
import './common/beta/Beta.sass';

//component style
import './ratingBoard/RatingBoard.sass';
import './fullScreenModal/FullScreenModal.sass';
import './assetTile/AssetTile.sass';
import './loading/LoadIndicator.sass';
import './assetList/AssetList.sass';
import './homeSection/FeaturedContent.sass';
import './filterPanel/FilterPanel.sass';
import './autoSuggest/AutoSuggest.sass';
import './header/PageHeader.sass';
import './header/Banner.sass';
import './assetDetail/AssetDetail.sass';
import './assetDetail/content/AssetDetailRating.sass';
import './shoppingCart/ShoppingCart.sass';
import './imageGallery/ImageGallery.sass';
import './linkDropDown/LinkDropDown.sass';
import './imageList/ImageList.sass';
import './review/ReviewImage.sass';
import './review/ReviewItem.sass';
import './review/Review.sass';
import './reviewDialog/ReviewDialog.sass';
